import { render, staticRenderFns } from "./ServicingReport.vue?vue&type=template&id=1fe13edc&scoped=true"
import script from "./ServicingReport.vue?vue&type=script&lang=js"
export * from "./ServicingReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fe13edc",
  null
  
)

export default component.exports